module.exports = __webpack_public_path__ + "img/visa_sc.854531d.svg";